module.exports = __webpack_public_path__ + "static/media/everypig-agent-icon.53c3c5f5.png";